export const BenefitEN = {
	"benefit": {
		"headingLabel": "Manager Benefit",
		"listBenefit": "List Benefit",
		"createBenefit": "Create Benefit",
		"updateBenefit": "Update Benefit"
	},
	"benefitColumns": {
		"name": "Benefit Name",
		"money": "Money/Unit",
		"tax": "Tax",
		"status": "Status"
	},
	"benefitActions": {
		"add": "Add Benefit",
		"update": "Update Benefit"
	},
	"benefitData": {
		"pending": "Non-active",
		"approved": "Active",
		"reject": "Reject",
		"trashed": "Trashed",
		"true": "Yes",
		"false": "No",
		"day": "Day",
		"month": "Month"
	},
	"benefitLabel": {
		"name": "Benefit name",
		"money": "Money",
		"tax": "Tax",
		"unit": "Unit"
	},
	"placeholderBenefit": {
		"name" : "Name",
		"money" : "Amount",
		"tax" : "Tax",
		"unit" : "Unit",
		"status" : "Status"
	}
}
